import { fetchPropertyTags } from 'actions/OfferActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'
import { EmptyObject } from 'lib/object/objectUtils'

interface PropertyTagsReturn {
  tags: Array<string> | undefined
  fetching: boolean
}

function usePropertyTags(
  propertyId: string | undefined,
  options: { disabled?: boolean } = EmptyObject,
): PropertyTagsReturn {
  const dispatch = useAppDispatch()

  const cleanPropertyId = useMemo(() => {
    return propertyId?.includes(':') ? propertyId.split(':')[1] : propertyId
  }, [propertyId])

  const propertyTagsState = useAppSelector(state => state.offer.propertyTags[cleanPropertyId ?? ''])

  useEffect(() => {
    if (!options.disabled && cleanPropertyId) {
      dispatch(fetchPropertyTags(cleanPropertyId))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cleanPropertyId, options.disabled])

  return {
    tags: propertyTagsState?.tags,
    fetching: propertyTagsState?.fetching ?? !options.disabled,
  }
}

export default usePropertyTags
